<template>
  <section class="sidebar">
    <section class="fullScreen" id="sidebar">
      <!-- ============================== Big Screen Sidebar -->
      <v-navigation-drawer
        class="main_sidebar"
        :class="mainNavOpen ? 'active' : ''"
        permanent
        :expand-on-hover="false"
        ref="mainSidebar"
      >
        <!-- Upper Scection -->
        <div class="top_logo">
          <!-- change sidebar -->
          <span @click.stop="toggleMainMenu" class="toggleMainMenue">
            <i class="fa fa-bars"></i>
          </span>
          <!-- change sidebar -->
          <div class="logo">
            <h2>{{ $t("dashName") }}</h2>
          </div>
          <!-- <div class="toggleResize">
          <button
            @click="toggleSideBarFullWidth"
            class="btn ful-w"
            :class="{ ful_back: menueMinWidth }"
          ></button>
        </div> -->
        </div>

        <!-- <v-divider></v-divider> -->
        <v-list>
          <template>
            <div class="d-flex align-items-center gap-3">
              <v-list-item to="/profile/edit" class="p-2 porfile-rap">
                <div class="d-flex align-items-center gap-3">
                  <div
                    class="img-raper rounded-circle d-flex align-items-center justify-content-center"
                    style="width: 50px; height: 50px; overflow: hidden"
                  >
                    <img
                      class=""
                      style="/* object-fit: cover; */ width: 100%; height: 100%"
                      v-if="current_theme == 'light'"
                      :src="
                        user.image && user.image !== 'null'
                          ? user.image
                          : require('@/assets/media/images/logo/admin.png')
                      "
                    />
                    <img
                      width="100"
                      class="img-fluid"
                      v-else
                      :src="
                        user.image && user.image !== 'null'
                          ? user.image
                          : require('@/assets/media/images/logo/logo_dark.png')
                      "
                    />
                  </div>
                  <div class="text">
                    <h3>{{ user.name }}</h3>
                    <p>{{ $t("labels.online") }}</p>
                    <span style="font-size: 10px"
                      >{{ user.activityname }}
                    </span>
                  </div>
                </div>
              </v-list-item>

              <!-- globe Lang icon -->
              <!-- <div class="mr-5">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <button v-on="on" class="lang-btn">
                      <i class="fal fa-globe"></i>
                    </button>
                  </template>

                  <v-list>
                    <v-list-item @click="changeLocale('en')">
                      <v-list-item-title>English</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="changeLocale('de')">
                      <v-list-item-title>Deutsch </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div> -->
            </div>

            <!-- Home Icon -->
            <v-list-item to="/">
              <v-icon>fas fa-home</v-icon>
              <v-list-item-title>{{ $t("navs.home") }}</v-list-item-title>
            </v-list-item>
          </template>
          <template v-for="item in sidebar">
            <div class="divider_new" v-if="item.label" :key="item.id">
              <span>{{ item.label }}</span>
            </div>

            <template v-for="sub_item in item.categories">
              <v-list-item
                v-if="sub_item.key == 'general'"
                :key="sub_item.id"
                :to="`/${sub_item.permissions[0].url}`"
              >
                <v-icon>{{ sub_item.icon }}</v-icon>
                <v-list-item-title>{{ sub_item.title }} </v-list-item-title>
              </v-list-item>
              <!-- If DropDown -->
              <v-list-group
                :key="sub_item.uuid"
                v-else
                :class="{
                  activeDropDown: sub_item.active,
                }"
                class="parnet"
                v-model="sub_item.active"
                :prepend-icon="sub_item.icon"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ sub_item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>

                <div v-for="child in sub_item.permissions" :key="child.id">
                  <v-list-item :to="`/${child.url}`">
                    <v-list-item-content>
                      <!-- <span class="polit"></span> -->
                      <v-list-item-title>{{ child.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </div>
              </v-list-group>
            </template>
          </template>
        </v-list>
      </v-navigation-drawer>
      <!-- ============================== Small Screen Sidebar -->
    </section>
    <aside class="smallScreenSidebar main_sidebar" ref="smallSidebar">
      <span @click.stop="toggleMenu" class="close">
        <i class="fas fa-times"></i>
      </span>

      <!-- Upper Scection -->
      <div class="top_logo">
        <div class="logo">
          <router-link to="/">
            <div style="width: 50px; height: 50px">
              <img
                class="img-fluid"
                style="width: 100%"
                v-if="current_theme == 'light'"
                src="@/assets/media/images/logo/logo_light.png"
              />
              <img
                style="width: 100%"
                class="img-fluid"
                v-else
                src="@/assets/media/images/logo/logo_dark.png"
              />
            </div>
          </router-link>
        </div>
      </div>
      <v-list>
        <v-list-item to="/profile/edit" class="p-2 porfile-rap">
          <div class="d-flex align-items-center gap-3">
            <div
              class="img-raper rounded-circle d-flex align-items-center justify-content-center"
              style="width: 50px; height: 50px; overflow: hidden"
            >
              <img
                class=""
                style="/* object-fit: cover; */ width: 100%; height: 100%"
                v-if="current_theme == 'light'"
                src="@/assets/media/images/logo/admin.png"
              />
              <img
                width="100"
                class="img-fluid"
                v-else
                src="@/assets/media/images/logo/logo_dark.png"
              />
            </div>
            <div class="text">
              <h3>Super Admin</h3>
              <p>{{ $t("labels.online") }}</p>
            </div>
          </div>
        </v-list-item>
        <v-list-item to="/">
          <v-icon>fas fa-home</v-icon>
          <v-list-item-title>{{ $t("navs.home") }}</v-list-item-title>
        </v-list-item>
        <template v-for="item in sidebar">
          <div class="divider_new" v-if="item.label" :key="item.id">
            <span>{{ item.label }}</span>
          </div>

          <template v-for="sub_item in item.categories">
            <v-list-item
              v-if="sub_item.key == 'general'"
              :key="sub_item.id"
              :to="`/${sub_item.permissions[0].url}`"
            >
              <v-icon>{{ sub_item.icon }}</v-icon>
              <v-list-item-title>{{ sub_item.title }}</v-list-item-title>
            </v-list-item>
            <!-- If DropDown -->
            <v-list-group
              v-else
              :key="sub_item.uuid"
              :class="{
                activeDropDown: sub_item.active,
              }"
              class="parnet"
              v-model="sub_item.active"
              :prepend-icon="sub_item.icon"
              @click.stop
            >
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>{{ sub_item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <template>
                <v-list-item
                  v-for="child in sub_item.permissions"
                  :to="`/${child.url}`"
                  :key="child.id"
                >
                  <v-list-item-content>
                    <!-- <span class="polit"></span> -->
                    <v-list-item-title>{{ child.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-list-group>
          </template>
        </template>
      </v-list>

      <ul class="navIcons" v-if="false">
        <!-- Theme -->
        <li v-if="current_theme == 'dark'" @click="changeTheme('light')">
          <i class="fal fa-sun"></i>
        </li>
        <li v-if="current_theme == 'light'" @click="changeTheme('dark')">
          <i class="fal fa-moon"></i>
        </li>

        <!-- Lang -->
        <li v-if="lang == 'ar'" @click="changeLang('en')">
          <i class="fal fa-globe"></i>
        </li>
        <li v-if="lang == 'en'" @click="changeLang('ar')">
          <i class="fal fa-globe"></i>
        </li>
      </ul>
    </aside>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      menueMinWidth: true,
      sidebar: [],
      mainNavOpen: true,
    };
  },

  methods: {
    changeLocale(locale) {
      console.log("Changing locale to:", locale);
      this.$i18n.locale = locale;
      localStorage.setItem("myTeam_Academy_Dash_Lang", locale);
      window.location.reload();
    },
    toggleSideBarFullWidth() {
      this.menueMinWidth = !this.menueMinWidth;
      this.$store.dispatch("sideNav_module/onResize");
    },

    toggleMenu() {
      this.$refs.smallSidebar.classList.toggle("active");
    },

    toggleMainMenu() {
      this.mainNavOpen = !this.mainNavOpen;
      const mainNav = document.querySelector(".main_nav");
      mainNav.classList.toggle("active");
      const mainWrapper = document.querySelector(".app-wrapper");
      mainWrapper.classList.toggle("active");
    },

    changeTheme(value) {
      this.$store.dispatch("theme_module/changeTheme", value);
      if (value == "light") {
        this.$vuetify.theme.dark = false;
      } else {
        this.$vuetify.theme.dark = true;
      }
      this.$refs.smallSidebar.classList.remove("active");
    },

    changeLang(value) {
      this.$store.dispatch("lang_module/switchLang", value);
      this.$refs.smallSidebar.classList.remove("active");
    },
    manipulateTheSideBarComplete() {
      // Convert 'JSON' Object to JS Object
      // console.log("sidebar", this.$t("sidebar"));
      const Json_Sidebar = JSON.parse(JSON.stringify(this.$t("sidebar")));
      Json_Sidebar.forEach((el) => {
        // IF Dropdown
        if (el.items) {
          // ======== Check Nested
          let inside_nested = false;
          el.items.forEach((element) => {
            if (element.items) {
              inside_nested = true;
            }
          });

          // ======== IF Nested Else
          if (inside_nested) {
            el.items.forEach((subEl) => {
              // Active
              subEl.activeRoutesMatch = subEl.items[0].url;

              // DropDown
              if (this.$route.path.includes(subEl.activeRoutesMatch)) {
                subEl.active = true;
              } else {
                subEl.active = false;
              }
            });
            el.activeRoutesMatch = el.parentUrl;

            // DropDown
            if (this.$route.path.includes(el.activeRoutesMatch)) {
              el.active = true;
            } else {
              el.active = false;
            }
          } else {
            el.activeRoutesMatch = el.items[0].url;

            // DropDown
            if (this.$route.path.includes(el.activeRoutesMatch)) {
              el.active = true;
            } else {
              el.active = false;
            }
          }
        }
      });
      this.sidebar = Json_Sidebar;
    },
    filterSidebarByPermissions(sidebar, permissions) {
      return sidebar
        .map((section) => {
          const filteredCategories = section.categories
            .map((category) => {
              const filteredPermissions = category.permissions.filter(
                (perm) => {
                  return permissions.some(
                    (control) => control.url === perm.url
                  );
                }
              );

              return {
                ...category,
                permissions: filteredPermissions,
              };
            })
            .filter((category) => category.permissions.length > 0);

          return {
            ...section,
            categories: filteredCategories,
          };
        })
        .filter((section) => section.categories.length > 0);
    },
    async manipulateTheSideBar() {
      let userPermissions = [];
      let Json_Sidebar = JSON.parse(JSON.stringify(this.$t("sidebar")));
      const datesPermissions = [
        {
          back_route_name: "Dates/show-all",
          icon: null,
          id: 146,
          title: "Dates.index",
          url: "Dates/show-all",
        },
        {
          back_route_name: "Dates.add",
          icon: null,
          id: 147,
          title: "Dates.add",
          url: "Dates/add",
        },
        {
          back_route_name: "Dates.edit",
          icon: null,
          id: 148,
          title: "Dates.edit",
          url: "Dates/edit",
        },
        {
          back_route_name: "Dates.delete",
          icon: null,
          id: 148,
          title: "Dates.delete",
          url: "Dates/delete",
        },
      ];
      this.axios.get("get_my_permissions").then((res) => {
        localStorage.setItem(
          "myTeam_Academy_Dash_permissions",
          JSON.stringify(res.data.data)
        );
        Json_Sidebar.forEach((el) => {
          // IF Dropdown
          if (el.items) {
            // ======== Check Nested
            let inside_nested = false;
            el.items.forEach((element) => {
              if (element.items) {
                inside_nested = true;
              }
            });

            // ======== IF Nested Else
            if (inside_nested) {
              el.items.forEach((subEl) => {
                // Active
                subEl.activeRoutesMatch = subEl.items[0].url;

                // DropDown
                if (this.$route.path.includes(subEl.activeRoutesMatch)) {
                  subEl.active = true;
                } else {
                  subEl.active = false;
                }
              });
              el.activeRoutesMatch = el.parentUrl;

              // DropDown
              if (this.$route.path.includes(el.activeRoutesMatch)) {
                el.active = true;
              } else {
                el.active = false;
              }
            } else {
              el.activeRoutesMatch = el.items[0].url;

              // DropDown
              if (this.$route.path.includes(el.activeRoutesMatch)) {
                el.active = true;
              } else {
                el.active = false;
              }
            }
          }
        });
        this.sidebar = this.filterSidebarByPermissions(
          JSON.parse(JSON.stringify(this.$t("sidebar"))),
          res.data.data
        );
        userPermissions = JSON.parse(
          localStorage.getItem("myTeam_Academy_Dash_permissions")
        );
        if (
          localStorage.getItem("myTeam_Academy_Dash_User_Is_Notifications") ==
          "1"
        ) {
          const notificationPermissions = [
            {
              id: 141,
              icon: null,
              title: "notifications.index",
              url: "notifications/show-all",
              back_route_name: "notifications.index",
            },
            {
              id: 142,
              icon: null,
              title: "notifications.store",
              url: "notifications/add",
              back_route_name: "notifications.store",
            },
            {
              id: 143,
              icon: null,
              title: "notifications.show",
              url: "notifications/show/",
              back_route_name: "notifications.show",
            },
            {
              id: 144,
              icon: null,
              title: "notifications.update",
              url: "notifications/edit/",
              back_route_name: "notifications.update",
            },
            {
              id: 145,
              icon: null,
              title: "notifications.destroy",
              url: "notifications/delete",
              back_route_name: "notifications.destroy",
            },
          ];

          //push notifications
          // userPermissions.push(notificationPermissions);
          // userPermissions = JSON.parse(
          //   localStorage.getItem("myTeam_Academy_Dash_permissions")
          // );
          localStorage.setItem(
            "myTeam_Academy_Dash_permissions",
            JSON.stringify([...userPermissions, ...notificationPermissions])
          );

          this.sidebar.push({
            label: "الاشعارات",
            icon: "",
            categories: [
              {
                icon: "fa-solid fa-users",
                permissions: [
                  {
                    title: "عرض الكل",
                    url: "notifications/show-all",
                  },
                  {
                    title: "اضافة جديد",
                    url: "notifications/add",
                  },
                ],
                title: "الاشعارات",
              },
            ],
          });
        } //end if

        const players_permission_exists = res.data.data.some(
          (item) =>
            //player permissions ids
            item.id == 93 ||
            item.id == 94 ||
            item.id == 94 ||
            item.id == 96 ||
            item.id == 97
        );

        if (players_permission_exists) {
          // userPermissions.push(...datesPermissions),
          localStorage.setItem(
            "myTeam_Academy_Dash_permissions",
            JSON.stringify([...userPermissions, ...datesPermissions])
          );
          // this.sidebar.push({
          //   label: "الفرق و المواعيد",
          //   icon: "",
          //   categories: [
          //     {
          //       icon: "fa-solid fa-store",
          //       permissions: [
          //         {
          //           title: "عرض الكل",
          //           url: "Dates/show-all",
          //         },
          //         {
          //           title: "اضافة جديد",
          //           url: "Dates/add",
          //         },
          //       ],
          //       title: "الفرق و المواعيد",
          //     },
          //   ],
          // });
          this.sidebar.splice(1, 0, {
            label: "الفرق و المواعيد",
            icon: "",
            categories: [
              {
                icon: "fa-solid fa-store",
                permissions: [
                  {
                    title: "عرض الكل",
                    url: "Dates/show-all",
                  },
                  {
                    title: "اضافة جديد",
                    url: "Dates/add",
                  },
                ],
                title: "الفرق و المواعيد",
              },
            ],
          });
        }

        // if (show_players_exists) {
        //   // userPermissions.push(datesPermissions[0]);
        //   localStorage.setItem(
        //     "myTeam_Academy_Dash_permissions",
        //     JSON.stringify([...userPermissions])
        //   );
        // }

        // console.log("sidebar", this.sidebar);
        // console.log(
        //   "userPermissions",
        //   localStorage.getItem("myTeam_Academy_Dash_permissions")
        // );
      });
    },
    getSideBar() {
      this.axios.get("side-bar-permissions").then((res) => {
        this.sidebar = res.data.data;
      });
    },
    andleShowLabels(item) {
      let currentPermissions = [];
      item.categories &&
        item.categories.map((category) => {
          category.permissions &&
            category.permissions.map((permission) => {
              currentPermissions.push(permission.url);
            });
        });
      return currentPermissions.some((url) => {
        return !this.$permission.allowed(url);
      });
    },
  },

  computed: {
    ...mapGetters({
      current_theme: "theme_module/current_theme",
      lang: "lang_module/lang",
      user: "auth_module/currentUser",
    }),
  },

  created() {
    this.control = this.$permission.setControls(this.$route.path);
    if (this.user.usertype == "academy") {
      this.manipulateTheSideBarComplete();
    } else {
      // this.getSideBar();
      // this.getPermissions();
      this.manipulateTheSideBar();
    }
  },
};
</script>

<style lang="scss"></style>
